import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=64bcb463&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bcb463')) {
      api.createRecord('64bcb463', component.options)
    } else {
      api.reload('64bcb463', component.options)
    }
    module.hot.accept("./Signup.vue?vue&type=template&id=64bcb463&", function () {
      api.rerender('64bcb463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/pages/Signup/Signup.vue"
export default component.exports